import { useTranslation } from 'react-i18next';
import { useFilteredTransactions } from '@/hooks/useFilteredTransactions';
import { formatNumber } from '@/lib/money';

/** Contador inline: "N de TOTAL transaccoes" (reactivo aos filtros). */
export function TransactionCounter() {
  const { count, totalCount, isFiltered } = useFilteredTransactions();
  const { t } = useTranslation();

  return (
    <div className="aiobi-tx-counter" role="status" aria-live="polite">
      {isFiltered
        ? t('filters.counter.filtered', {
            n: formatNumber(count),
            total: formatNumber(totalCount),
          })
        : t('filters.counter.all', { total: formatNumber(totalCount) })}
    </div>
  );
}
